<div class="resend-sms d-flex flex-column align-items-center">
  <div class="resend-sms-body">
    <div *ngIf="showSignMessage" class="resend-sms-content">
      <p class="resend-sms__text text-center">{{ 'RESEND.SIGN_MESSAGE' | translate }}</p>
    </div>
    <div *ngIf="showAuthMessage" class="resend-sms-content">
      <p *ngIf="!timeOut && showPhone" [innerHtml]="'AUTH.SHORT_TEXT' | translate" class="resend-sms__text text-center"></p>
      <p *ngIf="timeOut || !showPhone" class="resend-sms__text text-center">{{ 'CONFIRM.PHONE' | translate }}</p>
    </div>
  </div>
  <div
    [ngClass]="
        showPhone ? 'justify-content-md-between' : 'justify-content-md-center'
      "
    class="resend-sms-footer text-center d-flex flex-column"
  >
    <ng-container *ngIf="showIVR">
      <app-button
        (clickEvent)="resend(VerificationTypeEnum.IVR)"
        [label]="'BUTTON.REPEAT_PHONE' | translate"
        classes="fs-18 fw-medium"
        color="primary"
        size="large"
        type="button"
      >
      </app-button>
    </ng-container>
    <ng-container *ngIf="showPhone">
      <app-button
        (clickEvent)="resend(VerificationTypeEnum.PHONE)"
        [img]="{
            url: './assets/images/icons/icon-repeat-call.svg',
            width: '24px',
            height: '26px'
          }"
        [label]="'BUTTON.REPEAT_PHONE' | translate"
        classes="fs-18 fw-medium mb-3 mb-md-0"
        color="limpid"
        size="large"
        type="button"
      >
      </app-button>
    </ng-container>
    <app-button
      (clickEvent)="resend(VerificationTypeEnum.SMS)"
      [color]="otherResendSmsBntColor || 'limpid'"
      [img]="smsIcon"
      [label]="(otherResendSmsLabel ?? 'BUTTON.REPEAT_SMS') | translate"
      classes="fs-18 fw-medium"
      size="large"
      type="button"
    >
    </app-button>
    <app-button
      (click)="resend(VerificationTypeEnum.VIBER)"
      [img]="{url: 'assets/img/viber.png', height: '24px', width: '24px'}"
      [label]="('BUTTON.SEND_VIBER' | translate)"
      classes="fs-18 fw-medium"
      color="viber"
      size="large"
      type="button"
    >
    </app-button>
  </div>
</div>
